<section id="section-introducao">
  <div class="row">
    <div class="col-sm-12 col-md-6 show-on-mobile-only">
      <img alt="trabalhe-conosco" src="https://tag2u.s3.sa-east-1.amazonaws.com/landing-pages/trabalhe-conosco-1.png" />
    </div>

    <div class="col-sm-12 col-md-6">
      <h3>#teamtag</h3>
      <h1>Faça parte do nosso time de gigantes!</h1>

      <button mat-raised-button class="btn-candidatar pull-left" (click)="scrollTo('about')">Quero me candidatar</button>
    </div>

    <div class="col-sm-12 col-md-6 hide-on-mobile">
      <img alt="trabalhe-conosco" id="img-intro" src="https://tag2u.s3.sa-east-1.amazonaws.com/landing-pages/trabalhe-conosco-1.png" />
    </div>
  </div>
</section>

<section id="section-quem-somos">
  <h3>Quem somos?</h3>

  <div class="row">
    <div class="col-sm-12 col-md-4">
      <h1>RES.SIG.NI FI.CAN.DO</h1>
      <h2>MÓVEIS, LARES E VIDAS</h2>
    </div>

    <div class="col-sm-12 col-md-8">
      <h4>
        Somos uma plataforma que gerência a prospecção, precificação e a venda de móveis e produtos usados. Nossa proposta de valor é a desocupação
        imediata de espaços físicos através da coleta, distribuição e venda de móveis e produtos usados.
      </h4>
    </div>
  </div>
</section>

<section id="sobre">
  <h5>
    <b>Missão:</b> gerar impacto ambiental positivo no mundo através do incentivo a economia circular, ao reinserir móveis e produtos usados no
    mercado;
  </h5>
</section>

<section id="sobre" style="background-color: #ffffff">
  <h5><b>Visão:</b> Ser a maior plataforma de móveis e produtos usados do Brasil;</h5>
</section>

<section id="sobre">
  <h5><b>Valores:</b> Ética, transparência, sustentabilidade e inovação</h5>
</section>

<section id="section-beneficios">
  <h3>Fazendo parte da TAG2U você terá:</h3>
  <div class="row">
    <div class="col-sm-12 col-md-4">
      <mat-card>
        <mat-card-header>
          <img alt="descontos especiais" src="https://tag2u.s3.sa-east-1.amazonaws.com/landing-pages/trabalhe-conosco-icon-1.png" />
        </mat-card-header>
        <h4>Descontos especiais</h4>
      </mat-card>
    </div>
    <div class="col-sm-12 col-md-4">
      <mat-card>
        <mat-card-header>
          <img alt="ambiente leve e descontraído" src="https://tag2u.s3.sa-east-1.amazonaws.com/landing-pages/trabalhe-conosco-icon-2.png" />
        </mat-card-header>
        <h4>Ambiente de trabalho leve e descontraído</h4>
      </mat-card>
    </div>
    <div class="col-sm-12 col-md-4">
      <mat-card>
        <mat-card-header>
          <img alt="impacto ambiental" src="https://tag2u.s3.sa-east-1.amazonaws.com/landing-pages/trabalhe-conosco-icon-3.png" />
        </mat-card-header>
        <h4>Impacto ambiental</h4>
      </mat-card>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-12 col-md-4" id="about">
      <mat-card>
        <mat-card-header>
          <img alt="experiencia e pioneirismo" src="https://tag2u.s3.sa-east-1.amazonaws.com/landing-pages/trabalhe-conosco-icon-4.png" />
        </mat-card-header>
        <h4>Experiência e Pionerismo</h4>
      </mat-card>
    </div>
    <div class="col-sm-12 col-md-4">
      <mat-card>
        <mat-card-header>
          <img alt="aprendizado" src="https://tag2u.s3.sa-east-1.amazonaws.com/landing-pages/trabalhe-conosco-icon-5.png" />
        </mat-card-header>
        <h4>Aprendizado constante</h4>
      </mat-card>
    </div>
    <div class="col-sm-12 col-md-4">
      <mat-card>
        <mat-card-header>
          <img alt="plano de carreira" src="https://tag2u.s3.sa-east-1.amazonaws.com/landing-pages/trabalhe-conosco-icon-6.png" />
        </mat-card-header>
        <h4>Plano de carreira</h4>
      </mat-card>
    </div>
  </div>
</section>

<section id="section-form" *ngIf="showForm">
  <h3>Quero trabalhar na TAG2U:</h3>
  <div class="row">
    <div class="col-sm-12 col-md-8">
      <form [formGroup]="formCandidato" id="form" (submit)="salvar()">
        <mat-form-field appearance="outline" class="col-xs-12 col-sm-12">
          <mat-label>Nome</mat-label>
          <input type="text" id="nome" name="nome" formControlName="nome" matInput />
        </mat-form-field>

        <mat-form-field appearance="outline" class="col-xs-12 col-sm-12">
          <mat-label>Email</mat-label>
          <input type="text" id="email" name="email" formControlName="email" matInput />
        </mat-form-field>

        <mat-form-field appearance="outline" class="col-xs-12 col-sm-12">
          <mat-label>Contato</mat-label>
          <input type="text" id="contato" [textMask]="{ mask: masks.celular }" name="contato" formControlName="contato" matInput />
        </mat-form-field>

        <mat-form-field appearance="outline" class="col-xs-12 col-sm-12">
          <mat-label>Faça uma breve apresentação, gostariamos de te conhecer melhor!</mat-label>
          <textarea type="text" id="apresentacao" name="apresentacao" formControlName="apresentacao" matInput></textarea>
        </mat-form-field>

        <div class="row">
          <div class="col-sm-12">
            <h4 style="margin-bottom: 20px" *ngIf="event">
              {{ event.name }}
            </h4>

            <label class="input-file" type="button" for="input">
              <input type="file" id="input" name="fileInput" (change)="setEvent($event)" accept="application/pdf" />
              Anexar Currículo <br /><br />
            </label>
            <button mat-raised-button type="submit" color="primary" [disabled]="!formCandidato.valid">Enviar</button>
            <!-- <mat-error *ngIf="!formCandidato.valid">Por favor, anexe </mat-error> -->
          </div>
        </div>
      </form>
    </div>

    <div class="col-sm-12 col-md-4" id="tag">
      <img src="https://tag2u.s3.sa-east-1.amazonaws.com/landing-pages/logo_tag.png" alt="Logo tag2u" />

      <legend>Para comprar, vender ou reformar, entre em contato pelo whatsapp (11) 9 7828 8917 Atendimento exclusivo pelo whatsapp</legend>
    </div>
  </div>
</section>
